<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">{{
        General.PROCESS_MAX_SIZE
      }}</span>
      <div
        class="close-button cursor-pointer"
        role="button"
        :aria-label="General.CLOSE"
        @click.stop="close"
      >
        <b-icon icon="close" :type="isContrast ? 'is-white-dark' : ''" />
      </div>
    </header>

    <div class="modal-content-container px-35">
      <p class="has-text-left">
        {{ App.ProgressBar.HELP_INFORMATION_1 }}
      </p>
      <p class="has-text-left">
        {{ App.ProgressBar.HELP_INFORMATION_2 }}
      </p>
      <b-progress
        class="my-5 pt-20"
        :type="getBarColor"
        :value="getProgressValue"
      />
      <span class="has-text-color-7 has-text-right">{{
        getProgressLabel
      }}</span>

      <footer class="modal-card-foot">
        <div class="action-buttons">
          <b-button
            data-cy="CONFIRM_CLOSE"
            class="confirm"
            :label="General.OK.toUpperCase()"
            :type="isContrast ? 'is-white-dark' : 'is-green-lawn'"
            :expanded="isMobile"
            @click="close"
          >
          </b-button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { bytes2Size } from "@/utils/bytes2Size";
import { App, General } from "@/utils/constants";
import { PROCESS_FILES_MAX_SIZE } from "@/utils/enumerate";

export default {
  name: "ModalProcessSize",
  props: {
    currentSize: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      App,
      General
    };
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),

    getProgressValue() {
      return (this.currentSize / PROCESS_FILES_MAX_SIZE) * 100;
    },

    getProgressLabel() {
      const currenctSize = bytes2Size(this.currentSize),
        maxSize = bytes2Size(PROCESS_FILES_MAX_SIZE);

      return `${currenctSize}/${maxSize}`;
    },

    getBarColor() {
      const maxGreenSize = 0.6 * PROCESS_FILES_MAX_SIZE,
        maxOrangeSize = 0.9 * PROCESS_FILES_MAX_SIZE;

      if (this.currentSize < maxGreenSize) return "is-primary";
      else if (this.currentSize < maxOrangeSize) return "is-warning";
      else return "is-danger";
    }
  },

  methods: {
    close() {
      this.$parent.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  max-height: 75vh;
  width: 40vw;
  background-color: $color-1;
}

.modal-content-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
  color: $dark-white;
}

.modal-card-foot {
  display: flex;
  justify-content: flex-end;
  padding: 40px 0 20px;

  @media screen and (max-width: $tablet) {
    justify-content: center;
  }

  .action-buttons {
    .confirm {
      min-width: 100px;
    }
    @media screen and (max-width: $tablet) {
      display: flex;
      flex-direction: column;
      gap: 10px;
      flex: 1;
    }
  }
}
</style>
